import styles from './DishesTableTitleLayout.module.scss'

export const DishesTableTitleLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.root}>{children}</div>
}
